import React, { useEffect, useState } from 'react';
import Container from 'view/portal/pages/services-page/modules/Container';
import Form1 from './pages/Form1';
import FormEdit from './pages/FormEdit';
import FormPerbaikan from './pages/FormPerbaikan';

const CekPendaftaran = () => {
  const [ step, setStep ] = useState(1);
  const [ data, setData ] = useState({});
  const [ isProgressHidden, setIsProgressHidden ] = useState(true);
  const formName = [ 'Pendaftaran', 'Edit' ];
  const components = [
    Form1,
    FormEdit,
    FormPerbaikan
  ];
  const nextStep = () => setStep((prevStep) => prevStep + 1);

  const renderComponent = (thisIndex) =>
    components.map((Component, i) => {
      return (
        <Component
          key={ i }
          { ...data }
          setIsProgressHidden={ setIsProgressHidden }
          nextStep={ nextStep }
          setStep={ setStep }
          setData={ setData }
          isShow={ i + 1 === thisIndex ? true : false }
        />
      );
    });

  return (
    <>
      <Container full>{renderComponent(step)}</Container>
    </>
  );
};

export default CekPendaftaran;
